import { render, staticRenderFns } from "./resultPacs.vue?vue&type=template&id=35808ca2&scoped=true&"
import script from "./resultPacs.vue?vue&type=script&lang=js&"
export * from "./resultPacs.vue?vue&type=script&lang=js&"
import style0 from "./resultPacs.vue?vue&type=style&index=0&id=35808ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35808ca2",
  null
  
)

export default component.exports